import { useAPIGetSummary } from 'api/kinerja/tim-penilai-penilik/overview'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'

import type { Summary } from 'types/kinerja-tim-penilai-penilik'

type SummaryHooks = {
  summary: Summary
  apiStatus: string
}

export const useSummary = (): SummaryHooks => {
  const { period, isHavePeriod } = usePeriodContext()
  const { data: summary, status: apiStatus } = useAPIGetSummary({
    periodId: period.id,
    enabled: isHavePeriod,
  })

  return {
    summary,
    apiStatus,
  }
}
